<template>
  <BasePopup v-model="isExtinctHmoneyPopupOpen" customClass="custom-popup full mn-wd480 extinct-hmoney">
    <form>
      <div class="popup-header">
        <h3 class="title">소멸예정 H캐시</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div class="popup-body">
        <p class="multi-txt16">유효기간이 경과한 H캐시는 자동 소멸됩니다.<br />소멸 예정 H캐시를 확인하여 기간 내 사용하시기 바랍니다.</p>
        <div class="box-gray flex jc-c al-c mt28 pt24 pb24">
          <p class="fs18"><span class="text-gray">소멸예정 H캐시</span> <span class="text-green font-bold">{{ Number(props.extAmt??0).toLocaleString() }}</span>원 (30일 이내)</p>
        </div>
        <!-- 스크롤 영역 s -->
        <div class="scroll pb1 mt24">
          <table class="tbl-type top-border-gray">
            <caption>소멸 예정 H캐시 내역</caption>
            <colgroup>
              <col style="width:30%;">
              <col style="width:auto;">
              <col style="width:28%;">
            </colgroup>
            <thead>
              <tr class="sticky top">
                <th scope="col" class="small">유효기간</th>
                <th scope="col" class="small">거래명/비고</th>
                <th scope="col" class="small">소멸예정 H캐시</th>
              </tr>
            </thead>
            <tbody v-if="hcashList.length > 0">
              <tr v-for="(item, index) in hcashList" :key="index">
                <td class="small fs14">
                  <p>{{ HconCommonUtils.format.date(item.pntExtnDueDt,'YYYY-MM-DD') }}</p>
                  <p class="mt6">(D-{{ HconCommonUtils.format.dateDiff(new Date, item.pntExtnDueDt) }})</p>
                </td>
                <td class="small left fs14">
                  <p class="multi-txt15">{{ item.pntTrdCntn }}</p>
                  <p class="mt9 text-gray02">거래번호 : {{ item.pntApvNo }}</p>
                </td>
                <td class="small fs14"><p class="font-bold">{{ item.trdAmt.toLocaleString() }}원</p></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="nodata">소멸예정 H캐시 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 스크롤 영역 e -->
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box">
          <button type="button" class="btn lg" @click="handleClose">확인</button>
        </div>
      </div>
    </form>
  </BasePopup>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import BasePopup from '@/components/com/HconComBasePopup.vue'
import type { HcashInfoDto } from '~/types/hcash/backend-dto-types'


// 팝업
const isExtinctHmoneyPopupOpen = ref(true)
const fetchBuilder        = useHconFetchBuilder();
const hcashList = ref<HcashInfoDto[]>([]);

const emit = defineEmits(['success','cancel']);
// 팝업

const handleClose = () => {
  emit('cancel', 'f');
  isExtinctHmoneyPopupOpen.value = false
}

onMounted(async () => {
  getExtintionDueHcashList();
})

const getExtintionDueHcashList = () => {
fetchBuilder.get<TableDataInfo<HcashInfoDto>>('/api/v1/mypage/hcash/get-extintion-due-hcash-list')
      .query()
      .build().execute()
  .then((result) => {
          // ref 형식 변수에 값 즉시 세팅
          hcashList.value = result.data || [];
    });
}

const props = defineProps({
  extAmt: {
    type: Number,
    // default: ''
  },
})

</script>
<style lang="scss">
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>